import React, { useEffect, useState } from 'react';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import {colors} from '../components/Theme/WebTheme';
import Hero from "../components/Hero";
import Section from "../components/Section";
import SeoServices from "../components/SeoServices";
import SeoLinks from "../components/SeoLinks";
import Download from "../components/Download";
import { Helmet } from "react-helmet-async";

import { useSelector } from "react-redux";

const dashboardRoutes = [];

export default function LandingPage(props) {

  const auth = useSelector(state => state.auth);

  const { ...rest } = props;

  const [role, setRole] = useState();

  useEffect(() => {
    if (auth && auth.profile) {
      if(auth.profile.uid){
        let role = auth.profile.usertype;
        setRole(role);
      }
    }
  }, [auth]);

  return (
    <div style={{backgroundColor:colors.LandingPage_Background,margin:'-8px'}}>
      <Helmet>
        <html lang="es" />
        <title>Grúas en Colombia | Grúa para carro, moto, maquinaria y grúa niñera - Movex</title>
        <meta name="description" content="Solicita una grúa en Colombia en minutos con Movex: grúa para carro, grúa para moto, grúas para maquinaria y grúa niñera. Precio y tiempo estimado antes de confirmar, conductor verificado y seguimiento en tiempo real. Servicio de grúa y auxilio vial 24/7." />
        <meta name="keywords" content="grúa, grúa Colombia, grúa para carro, grúa para moto, grúas para maquinaria, grúa niñera, grúa cerca de mí, servicio de grúa, auxilio vial, grúa a domicilio, grúa 24 horas, grúa Bogotá, grúa Medellín, grúa Cali, grúa plataforma, grúa de gancho, Movex" />
        <link rel="canonical" href="https://movex.com.co/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_CO" />
        <meta property="og:url" content="https://movex.com.co/" />
        <meta property="og:title" content="Grúas en Colombia | Grúa para carro, moto, maquinaria y grúa niñera - Movex" />
        <meta property="og:description" content="Grúa para carro, moto, maquinaria y grúa niñera en Colombia. Precio y ETA antes de confirmar, conductor verificado y seguimiento en tiempo real." />
        <meta property="og:image" content="https://movex.com.co/apple-icon.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="geo.region" content="CO" />
        <meta name="geo.placename" content="Colombia" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "AutomotiveBusiness",
            "name": "Movex",
            "image": "https://movex.com.co/apple-icon.png",
            "url": "https://movex.com.co/",
            "priceRange": "$$",
            "areaServed": { "@type": "Country", "name": "Colombia" },
            "description": "Servicio de grúas y auxilio vial en Colombia: grúa para carro, grúa para moto, grúas para maquinaria y grúa niñera, con precio y tiempo estimado antes de confirmar.",
            "makesOffer": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Grúa para carro", "areaServed": { "@type": "Country", "name": "Colombia" } } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Grúa para moto", "areaServed": { "@type": "Country", "name": "Colombia" } } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Grúas para maquinaria", "areaServed": { "@type": "Country", "name": "Colombia" } } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Grúa niñera", "areaServed": { "@type": "Country", "name": "Colombia" } } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Auxilio vial 24 horas", "areaServed": { "@type": "Country", "name": "Colombia" } } }
            ]
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              { "@type": "Question", "name": "¿Cómo pido una grúa para carro en Colombia?", "acceptedAnswer": { "@type": "Answer", "text": "Con Movex solicitas una grúa para carro desde la app en minutos: ves el precio y el tiempo estimado antes de confirmar, con conductor verificado y seguimiento en tiempo real." } },
              { "@type": "Question", "name": "¿Tienen grúa para moto?", "acceptedAnswer": { "@type": "Answer", "text": "Sí. Movex cuenta con grúa para moto con anclajes adecuados para trasladar tu motocicleta de forma segura tras una avería o accidente." } },
              { "@type": "Question", "name": "¿Movilizan maquinaria pesada?", "acceptedAnswer": { "@type": "Answer", "text": "Sí, ofrecemos grúas para maquinaria pesada y equipos industriales con plataformas de alta capacidad y operadores especializados en toda Colombia." } },
              { "@type": "Question", "name": "¿Qué es una grúa niñera?", "acceptedAnswer": { "@type": "Answer", "text": "La grúa niñera es una plataforma camabaja que transporta uno o varios vehículos sobre la plataforma sin rodar sus llantas, ideal para autos de alta gama o traslados largos." } }
            ]
          }
        `}</script>
      </Helmet>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Hero role={role}/>
      <Section role={role} color={colors}/>
      <SeoServices />
      <SeoLinks />
      <Download />
      <HomeFooter />
    </div>
  );
}
